export default function isNumber(value?: number | string): boolean {
  return !!value && /^[0-9-.]+$/.test(value.toString())
}
